import './PageTitleSlim.css';
import React from "react";

const PageTitleSlim = ({ title }) => {
    return (
        <section className='page-title-slim'>
            <div className="container">
                <div className="headline">
                    <h1>{title}</h1>
                </div>
            </div>
        </section>
    );
}

export default PageTitleSlim;
